import React from 'react';

// Shared page footer — a top hairline, the copyright/descriptor line on
// the left, and the angled "Powered by …" badge on the right. Used on
// both the admin app and the supplier portal so the family footer reads
// identically. The badge brand differs by surface: admin is powered by
// CORE (the internal platform), the supplier portal by Alchemy (the
// supplier-facing product). Tokens only; matches the Quotezilla footer.
export default function AppFooter({ poweredBy = 'CORE' }) {
  return (
    <footer className="border-t border-line mt-12 pt-5 pb-2 flex items-center justify-between gap-4 flex-wrap">
      {/* Build #18 §7a: dropped the internal "Supplier Operations Manager"
          descriptor — it read as an internal system name on supplier
          surfaces. Neutral wording works for both admin + supplier.
          ("(prototype)" left pending confirmation.) */}
      <p className="font-['Metropolis'] text-[13px] text-ink-secondary">
        © 2026 Supply Pilot · Fusion 2K{' '}
        <span className="text-ink-tertiary">(prototype)</span>
      </p>
      {/* Build #18 §1b: grey CORE wordmark on the page surface — no dark /
          angled capsule (matches BRIEF-20 §1 for the admin footer too). */}
      <p
        className="font-['Metropolis'] text-[10px] tracking-[0.02em] text-ink-tertiary"
        aria-label={`Powered by ${poweredBy}`}>
        Powered by <b className="font-extrabold tracking-[0.2em] text-ink-secondary">{poweredBy}</b>
      </p>
    </footer>
  );
}
